import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahBudgets } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = `budgets-services`;

const config = [{ actionType: 'getAll', apiPath: `${apiSahBudgets}/sections/items`, method: get }];

export interface ExternalBudgetService {
  item_id: string;
  service_type_id: number | null;
  purchase_order_number: string | null;
  shift: { id: string; name: string } | null;
  ph_shift: { id: string; name: string } | null;
  budget: {
    id: string;
    start_date: string;
    end_date: string;
    client_package_id: number | null;
    reference: string;
    status: string;
  } | null;
}

export interface ExternalServicesArg {
  client_id: number;
  date: string;
  package_id?: number;
}

export const budgetExternalServicesApi = createApi({
  reducerPath: 'budgetExternalServicesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahBudgets }),
  endpoints: (builder) => ({
    getBudgetExternalServices: builder.query<ExternalBudgetService[], ExternalServicesArg>({
      query: (params) => ({ url: '/sections/items/external', method: 'GET', params }),
      // Manual per-row Refresh (RefreshActionButton → refreshItemMeta) must always
      // re-pull budget services. preloadItemMeta fetches the same args on modal open,
      // so the default keepUnusedDataFor: 60 would serve a stale cache to Refresh
      // within 60s (silent no-op). Dropping retention to 0 keeps the in-flight dedup
      // this migration is about — the preload fan-out is a concurrent Promise.all, so
      // all callers still join one in-flight request — while removing the staleness
      // window. Mirrors getPaymentBatchPreview in direct-debits/actions/paymentBatches.ts.
      keepUnusedDataFor: 0,
      transformResponse: (payload) => unwrap<ExternalBudgetService[]>(payload),
    }),
  }),
});

export const { useLazyGetBudgetExternalServicesQuery } = budgetExternalServicesApi;

export const { getAll } = createThunks(typePrefix, config);
